// extracted by mini-css-extract-plugin
var _1 = "ReportProblems__attempt--G5Y5e";
var _2 = "ReportProblems__baoFont--LHjDi SchoolGeneral__bao--hA8gR OfficeGeneral__baoFont--nS_70 CoreGeneral__baoFont--dcsOj";
var _3 = "ReportProblems__blockName--X6r4O";
var _4 = "ReportProblems__circle--myvIJ";
var _5 = "ReportProblems__circleSelected--NwMe6 ReportProblems__circle--myvIJ";
var _6 = "ReportProblems__details--gHtBi";
var _7 = "ReportProblems__dot--x0Egc ReportMainBody__dot--Mxiiv";
var _8 = "ReportProblems__empty--fuuJW ReportProblems__circle--myvIJ ReportProblems__round--PEyti";
var _9 = "ReportProblems__emptySelected--E66yU ReportProblems__circleSelected--NwMe6 ReportProblems__circle--myvIJ ReportProblems__round--PEyti";
var _a = "ReportProblems__loading--F9tPr";
var _b = "ReportProblems__lock--ioFmX";
var _c = "ReportProblems__main--xbkoU";
var _d = "ReportProblems__nav--PQhGJ";
var _e = "ReportProblems__navLeft--afUXl";
var _f = "ReportProblems__navRight--dkR4z";
var _10 = "ReportProblems__noSolution--Vcxi5";
var _11 = "ReportProblems__numTrials--Ues7D";
var _12 = "ReportProblems__outdated--JENsw";
var _13 = "ReportProblems__printIcon--rb2kH ReportMainBody__printIcon--aItmC OfficeGeneral__baoFont--nS_70 CoreGeneral__baoFont--dcsOj";
var _14 = "ReportProblems__problem--c9ab7";
var _15 = "ReportProblems__round--PEyti";
var _16 = "ReportProblems__scrollContent--c09KZ";
var _17 = "ReportProblems__sectionTitle--qJopa";
var _18 = "ReportProblems__skip--dS0mQ";
var _19 = "ReportProblems__studentName--N3q4t";
var _1a = "ReportProblems__time--GsZrU";
var _1b = "ReportProblems__timeLabel--jUb3V";
var _1c = "ReportProblems__timeSpent--LUx7x";
var _1d = "ReportProblems__timeVal--oZpIm";
var _1e = "ReportProblems__top--drH4c CoreGeneral__textSizeF--R09QW";
var _1f = "ReportProblems__trainerLink--YTsSn";
var _20 = "ReportProblems__trials--AH342";
var _21 = "ReportProblems__trophy--wBf2e";
var _22 = "ReportProblems__unavailable--B9TNH";
export { _1 as "attempt", _2 as "baoFont", _3 as "blockName", _4 as "circle", _5 as "circleSelected", _6 as "details", _7 as "dot", _8 as "empty", _9 as "emptySelected", _a as "loading", _b as "lock", _c as "main", _d as "nav", _e as "navLeft", _f as "navRight", _10 as "noSolution", _11 as "numTrials", _12 as "outdated", _13 as "printIcon", _14 as "problem", _15 as "round", _16 as "scrollContent", _17 as "sectionTitle", _18 as "skip", _19 as "studentName", _1a as "time", _1b as "timeLabel", _1c as "timeSpent", _1d as "timeVal", _1e as "top", _1f as "trainerLink", _20 as "trials", _21 as "trophy", _22 as "unavailable" }
